import { Module, VuexModule, Mutation } from "vuex-module-decorators";
import subDays from "date-fns/subDays";
import endOfDay from "date-fns/endOfDay";

@Module({
  namespaced: true,
  name: "DisconnectHistory"
})
export default class DisconnectHistory extends VuexModule {
  disconnectedHistoryStart = subDays(new Date(), 1);
  disconnectedHistoryEnd = endOfDay(new Date());

  @Mutation
  sedisconnectedHistoryStart(date: Date) {
    this.disconnectedHistoryStart = date;
  }

  @Mutation
  sedisconnectedHistoryEnd(date: Date) {
    this.disconnectedHistoryEnd = date;
  }
}
